import * as constants from './constants'

const initialState = {
    isPopupShow: true
}
export default function store(state = initialState, action) {
    const actions = action;
    
    switch (actions.type) {
        case constants.SET_POPUP_STATUS: {
            return {
                ...state,
                isPopupShow: action.payload
            }
            
        }
        default: {
            return state;
        }
    }
}